import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { requestP360PartnerFlags } from 'partner360/features/p360PartnerFlags/api/requestP360PartnerFlags'

import {
  setCockpitFilterPartnerClasses,
  setCockpitSelectedPartnerIds,
} from '../financialCockpitSlice'
import {
  selectCockpitFilterPartnerClasses,
  selectCockpitPartnerClassOptions,
  selectCockpitRtm,
} from '../selectors'

// Both panel layouts must initialize and validate the same filter state.
export const useCockpitFilterInitialization = () => {
  const dispatch = useAppDispatch()
  const selectedRtm = useSelector(selectCockpitRtm)
  const selectedPartnerClasses = useSelector(selectCockpitFilterPartnerClasses)
  const partnerClassOptions = useSelector(selectCockpitPartnerClassOptions)

  useEffect(() => {
    dispatch(requestP360PartnerFlags())
  }, [dispatch])

  useEffect(() => {
    dispatch(setCockpitSelectedPartnerIds([]))
  }, [dispatch, selectedRtm])

  useEffect(() => {
    const validPartnerClasses = selectedPartnerClasses.filter((partnerClass) =>
      partnerClassOptions.some((flag) => flag.PartnerFlag === partnerClass)
    )
    if (validPartnerClasses.length !== selectedPartnerClasses.length) {
      dispatch(setCockpitFilterPartnerClasses(validPartnerClasses))
    }
  }, [dispatch, partnerClassOptions, selectedPartnerClasses])
}
